// JavaScript Document
$(function () {
	/*
======================
BODY FADE IN
======================
*/

	setTimeout(function () {
		$("body").removeClass("fade-out");
	}, 320);

	setTimeout(function () {
		$("body").addClass("loaded");
		$("#page-loader").fadeOut(900);
		$(".page-wrap").removeClass("fade-out");
	}, 1200);

	/*
===============================
ADDITIONAL BODYCLASSES
===============================
*/

	if (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1) {
		$("html").addClass("safari");
	}

	/*
================================
SCROLL ANIMATIONS (WOW JS)
================================
*/

	var wow = new WOW({
		boxClass: "wow",
		animateClass: "animated",
		offset: 0,
		mobile: true,
		live: true,
		scrollContainer: null,
		resetAnimation: false,
	});
	wow.init();

	/*
=========================
OBJECT FIT
=========================
*/

	$(function () {
		objectFitImages("img.object-fit");
	});

	/*
=====================
TEL LINKS
=====================
*/

	//Disable on desktop (non touch)...
	$(".no-touch a.tel").on("click", function (e) {
		e.preventDefault();
	});

	/*
=====================
TABLE WRAPPER
=====================
*/

	$("table").wrap('<div class="table-wrap"></div>');

	/*
======================
IFRAME WRAPPER
======================
*/

	$(".page-section iframe").wrap('<div class="iframe-wrap"></div>');

	/*
===============================
FIXED HEADER
===============================
*/

	//add header class
	$(window).on("scroll", function () {
		if ($(this).scrollTop() > 1) {
			$("#masthead").addClass("scrolled");
		} else {
			$("#masthead").removeClass("scrolled");
		}
	});

	//check page position and add class if not at the top of page on load
	var pagePostion = $(window).scrollTop();

	if (pagePostion > 1) {
		$("#masthead").addClass("scrolled");
	} else {
		$("#masthead").removeClass("scrolled");
	}

	/*
======================
HAMBURGER MENU
======================
*/

	//open menu
	$(".menu-toggle").on("click", function () {
		$("body").toggleClass("mobile-navigation--open");
		$(this).toggleClass("active");
		$(".mobile-navigation").toggleClass("active");
	});

	$("#mobile-navigation .menu-item-has-children").append('<div class="menu-expand"><i class="fa-sharp fa-solid fa-chevron-down"></i></div>');

	$(".menu-expand").on("click", function () {
		$(this).toggleClass("active");
		$(this).parent("li").toggleClass("active");
		$(this).parent("li").toggleClass("sub-menu-open");
		$(this).parent("li").find("> ul.sub-menu").slideToggle(600);
	});

	//hover class
	$("#header-navigation ul li")
		.on("mouseenter", function () {
			$(this).addClass("active-hover");
		})
		.on("mouseleave", function () {
			$(this).removeClass("active-hover");
		});

	$(".main-menu .close").on("click", function () {
		$(".hamburger").removeClass("active");
		$(".main-menu").removeClass("active");
	});

	/*
================================
MENU AIM
================================
*/

	var $menu = $(".main-menu .desktop-menu ul");

	$menu.menuAim({
		activate: activateSubmenu,
		deactivate: deactivateSubmenu,
	});

	function activateSubmenu(row) {
		var $row = $(row),
			$submenu = $row.children("ul");

		$row.children("a").addClass("hover");
		$submenu.css({display: "block"});
	}

	function deactivateSubmenu(row) {
		var $row = $(row),
			$submenu = $row.children("ul");

		$row.find("a").removeClass("hover");
		$submenu.css("display", "none");
	}

	$(document).click(function () {
		$(".main-menu .desktop-menu ul li a.hover").removeClass("hover");
	});

	/*
=======================================
RESPONSIVE DATA TABLES
======================================
*/

	var tables = document.querySelectorAll(".page-section .table-wrap table");
	for (var a = 0; a < tables.length; a++) {
		var headertext = [];
		var headers = tables[a].querySelectorAll("thead td"),
			tablebody = tables[a].querySelector("tbody");

		for (var i = 0; i < headers.length; i++) {
			var current = headers[i];
			headertext.push(current.textContent.replace(/\r?\n|\r/, ""));
		}
		for (var i = 0, row; (row = tablebody.rows[i]); i++) {
			for (var j = 0, col; (col = row.cells[j]); j++) {
				col.setAttribute("data-th", headertext[j]);
			}
		}
	}

	/*
======================================
SMOOTH SCROLL
======================================
*/

	// SMOOTH SCROLLING FROM ANOTHER PAGE TO CORRECT ID
	//START AT TOP OF PAGE AND SCROLL DOWN ALWAYS
	if (window.location.hash) {
		setTimeout(function () {
			$("html, body").scrollTop(0).show();
			$("html, body").animate(
				{
					scrollTop: $(window.location.hash).offset().top - 0,
				},
				1000
			);
		}, 0);
	} else {
		$("html, body").show();
	}

	//SMOOTH SCROLLING
	// Select all links with hashes
	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.click(function (event) {
			// On-page links
			if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$("html, body").animate(
						{
							scrollTop: target.offset().top - 0,
						},
						1000,
						function () {
							// Callback after animation
							// Must change focus!
						}
					);
				}
			}
		});

	/*
=========================
ACCORDION
=========================
*/

	$(".accordion-item .toggle-header").on("click", function () {
		$(this).parent(".accordion-item").toggleClass("active");
		$(this).next(".toggle-content").slideToggle("slow");
	});

	/*
=========================
UP ARROW
=========================
*/

	$(".up").on("click", function (event) {
		event.preventDefault();
		$("body,html").animate({scrollTop: 0}, 1000);
	});

	/*
==========================
BUTTONS
==========================
*/

	if ($("p .button").length > 0) {
		$("p").each(function () {
			if ($(this).find(".button").length === 2) {
				$(this).addClass("two-buttons");
			}
		});
	}

	/*
==========================
SLIDERS
==========================
*/

	//Banner Slider
	var swiper1 = new Swiper(".banner-slider .swiper", {
		/*navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},*/
		autoplay: true,
		loop: true,
		effect: "fade",
		slidesPerView: 1,
		spaceBetween: 50,
		centeredSlides: true,
		centeredSlidesBounds: true,
		navigation: false,
		pagination: {
			el: ".banner-slider .swiper-pagination",
		},
	});

	//Small Image slider
	var swiper2 = new Swiper(".swiper-6-slides", {
		slidesPerView: 3,
		spaceBetween: 10,
		navigation: {
			nextEl: ".small-image-slider .swiper-button-next",
			prevEl: ".small-image-slider .swiper-button-prev",
		},
		pagination: {
			el: ".small-image-slider .swiper-pag",
		},
		breakpoints: {
			900: {
				slidesPerView: 4,
				spaceBetween: 50,
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 70,
			},
			1600: {
				slidesPerView: 6,
				spaceBetween: 100,
			},
		},
	});

	var swiper2 = new Swiper(".accreditation-slider", {
		slidesPerView: 2,
		spaceBetween: 10,
		// navigation: {
		// 	nextEl: ".small-image-slider .swiper-button-next",
		// 	prevEl: ".small-image-slider .swiper-button-prev",
		// },
		pagination: {
			el: ".small-image-slider .swiper-pag",
		},
		breakpoints: {
			900: {
				slidesPerView: 4,
				spaceBetween: 50,
			},
			1200: {
				slidesPerView: 6,
				spaceBetween: 70,
			},
			1600: {
				slidesPerView: 8,
				spaceBetween: 100,
			},
		},
	});

	//Large Image Slider
	var swiper3 = new Swiper(".mySwiper3", {
		spaceBetween: 20,
		slidesPerView: 3,
		freeMode: true,
		watchSlidesProgress: true,
		navigation: {
			nextEl: ".large-image-slider .swiper-button-next",
			prevEl: ".large-image-slider .swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pag-2",
		},
		breakpoints: {
			900: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 20,
			},
		},
	});

	var swiper4 = new Swiper(".mySwiper4", {
		slidesPerView: 1,
		thumbs: {
			swiper: swiper3,
		},
	});

	swiper4.on("slideChange", () => {
		swiper3.slideTo(swiper4.activeIndex);
	});

	//reviews carousel
	var swiper2 = new Swiper(".reviews-carousel", {
		slidesPerView: 1,
		spaceBetween: 50,
		centeredSlides: false,
		centeredSlidesBounds: false,
		loop: true,
		navigation: {
			nextEl: ".reviews-carousel .swiper-button-next",
			prevEl: ".reviews-carousel .swiper-button-prev",
		},
		pagination: {
			el: ".reviews-carousel .swiper-pagination",
		},
		breakpoints: {
			680: {
				slidesPerView: 1,
				spaceBetween: 40,
			},
			850: {
				slidesPerView: 2,
				spaceBetween: 80,
			},
			1280: {
				slidesPerView: 3,
				spaceBetween: 80,
			},
		},
	});

	//Single Page Related Content
	var swiper5 = new Swiper(".related__swiper", {
		slidesPerView: 1,
		spaceBetween: 0,
		navigation: {
			nextEl: ".reviews .swiper-button-next",
			prevEl: ".reviews .swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pag-4",
		},
		breakpoints: {
			600: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1600: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
		},
	});

	/*
==========================
RECAPTCHA FADEOUT
==========================
*/

	$(window).on("scroll", function () {
		var documentHeight = $(document).height();
		var windowHeight = $(window).height();
		var scrollPosition = $(window).scrollTop();

		if (documentHeight - (windowHeight + scrollPosition) < 100) {
			$(".grecaptcha-badge").addClass("fade");
		} else {
			$(".grecaptcha-badge").removeClass("fade");
		}
	});

	/*
==========================
AJAX
==========================
*/

	//LOAD MORE POSTS
	$(".news-posts .posts-container").on("click", ".load-more", function (e) {
		e.preventDefault();

		var loaded = $("input.post-count").val();

		$.ajax({
			url: "/wp-admin/admin-ajax.php",
			type: "POST",
			data: {
				action: "load_more_posts",
				already_loaded: loaded,
			},
			beforeSend: function () {
				$(".news-posts .posts-container .load-more-posts").fadeTo(600, 0, function () {
					$(".news-posts .posts-container .load-more-posts").html('<div class="load"></div>');
				});
				$(".news-posts .posts-container .load-more-posts").delay(300).fadeTo(400, 1);
			},
			success: function (data) {
				$(".news-posts .posts-container .load-more-posts")
					.delay(1000)
					.fadeOut(700, function () {
						$(".news-posts .posts-container .load-more-posts").remove();
						$(".news-posts .posts-container").append(data);
					});
			},
		});
	});
}); //end document.ready


// function setQuantityField() {
//     const quantityField = document.querySelector('#input_2_16_1');
//     if (quantityField) {
//       console.log('Quantity field found, setting to 1');
//       quantityField.value = 1;
//       quantityField.readOnly = true;
//     } else {
//       console.log('Quantity field not on this page');
//     }
//   }

//   // Run this after every form page render
//   document.addEventListener('gform_post_render', function(event, formId) {
//     if (formId === 2) {
//       setQuantityField();
//     }
//   });

jQuery(document).ready(function ($) {
	function addImageAfterMatchingLabels() {
		// Remove previously inserted images
		$(".inserted-form-image").remove();

		// Loop through each h2 inside .product-parent
		$(".product-parent h2").each(function () {
			const h2Text = $(this).text().trim().toLowerCase();
			const parent = $(this).parent();

			// Loop through each checkbox label inside input_2_10
			$("#input_2_1 label, #input_2_13 label, #input_2_7 label").each(function () {
				const labelText = $(this).text().trim().toLowerCase();

				if (h2Text === labelText) {
					// Find the corresponding img inside .service-parent
					const img = $(parent).find(".form-card-image");

					// If an img is found, insert it after the matching label
					if (img.length) {
						$(this).before(img.clone().addClass("inserted-form-image")); // Tag the clone
					}
				}
			});
		});
	}

	// Run on form load and rerun after each Gravity Forms event
	$(document).on("gform_post_render", addImageAfterMatchingLabels);

	// Initial call when the page first loads
	addImageAfterMatchingLabels();
});